import React, { useEffect, useState } from "react";
import Gallery from "../components/Gallery";
import { getStorage, ref, listAll, getDownloadURL } from "firebase/storage";

import "../components/about.css";

function About() {
  const [posters, setPosters] = useState([]);

  function getPopularPosters() {
    const storage = getStorage();
    const listRef = ref(storage, "history");
    listAll(listRef)
      .then((res) => {
        const posterPromises = res.items.map((itemRef) => {
          return getDownloadURL(itemRef).then((url) => {
            return {
              url: url,
              likes: "1k",
              liked_by_user: Math.floor(Math.random() * 10) % 2 === 0,
            };
          });
        });

        Promise.all(posterPromises).then((newPosters) => {
          setPosters(newPosters);
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    getPopularPosters();
  }, []);

  return (
    <>
      {/* ... (your existing JSX) */}
      <div className="content">
        <h2>Gallery</h2>
        <p>Some of our most recent posters.</p>
        <Gallery posters={posters} />
      </div>
    </>
  );
}

export default About;
